import {ProfileProvider, ProfileContext} from 'contexts/ProfileContext';
import {useContext, useEffect, useState} from 'react';
import Form from 'react-bootstrap/Form';
import {GenericBrandedWrapper} from './Login';
import {doc, getFirestore, updateDoc} from 'firebase/firestore';
import {getAuth} from 'firebase/auth';
import {Loading} from 'components/loading/Loading';
import {useShowDeveloperButtonIfHidden} from 'contexts/DeveloperToolsContext';
import {useTranslateFunction} from 'contexts/translation/TranslationContext';

export const Unsubscribe = () => {
  useShowDeveloperButtonIfHidden();

  return (
    <ProfileProvider>
      <GenericBrandedWrapper>
        <UnsubscribeInner />
      </GenericBrandedWrapper>
    </ProfileProvider>
  );
};

const UnsubscribeInner = () => {
  const {loading, userData} = useContext(ProfileContext);
  const [okToEmail, setOkToEmail] = useState(true);
  const [okToSendNotifications, setOkToSendNotifications] = useState(true);
  const [okToSendSectionReminders, setOkToSendSectionReminders] =
    useState(true);
  const db = getFirestore();
  const t = useTranslateFunction('miscUI');

  useEffect(() => {
    if (!loading) {
      // eslint-disable-next-line @eslint-react/hooks-extra/no-direct-set-state-in-use-effect -- TODO: [#915](https://github.com/CodeinPlace/cip-webapp/issues/915) - fix legacy lint issue
      setOkToEmail(userData.okToEmail);
      // eslint-disable-next-line @eslint-react/hooks-extra/no-direct-set-state-in-use-effect -- TODO: [#915](https://github.com/CodeinPlace/cip-webapp/issues/915) - fix legacy lint issue
      setOkToSendNotifications(userData.okToSendNotifications);
      // eslint-disable-next-line @eslint-react/hooks-extra/no-direct-set-state-in-use-effect -- TODO: [#915](https://github.com/CodeinPlace/cip-webapp/issues/915) - fix legacy lint issue
      setOkToSendSectionReminders(userData.okToSendSectionReminders);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- TODO: [#915](https://github.com/CodeinPlace/cip-webapp/issues/915) - fix legacy lint issue
  }, [loading]);

  const updateUserEmailPreference = async () => {
    const isOk = !okToEmail;
    const auth = getAuth();
    if (!auth.currentUser) {
      return;
    }

    const userDoc = doc(db, 'users', auth.currentUser.uid);

    await updateDoc(userDoc, {
      okToEmail: isOk,
    });
    setOkToEmail(isOk);
  };

  const updateUserNotificationPreference = async () => {
    const isOk = !okToSendNotifications;
    const auth = getAuth();
    if (!auth.currentUser) {
      return;
    }

    const userDoc = doc(db, 'users', auth.currentUser.uid);

    await updateDoc(userDoc, {
      okToSendNotifications: isOk,
    });
    setOkToSendNotifications(isOk);
  };

  const updateUserSectionReminderPreference = async () => {
    const isOk = !okToSendSectionReminders;
    const auth = getAuth();
    if (!auth.currentUser) {
      return;
    }

    const userDoc = doc(db, 'users', auth.currentUser.uid);

    await updateDoc(userDoc, {
      okToSendSectionReminders: isOk,
    });
    setOkToSendSectionReminders(isOk);
  };

  if (loading) {
    return <Loading />;
  }

  return (
    <div className="d-flex flex-column align-items-center px-2">
      <h3 className="text-center">{t('Unsubscribe')}</h3>
      <hr />
      <div className="d-flex flex-column flex-fill gap-4">
        <PreferenceToggle
          label="Send me important emails:"
          ariaLabel="Mark this switch if it is OK for Code in Place to send you emails"
          checked={okToEmail}
          onChange={updateUserEmailPreference}
          id="pref-switch-email"
        />
        <PreferenceToggle
          label="Send me forum response emails:"
          ariaLabel="Mark this switch if it is OK for Code in Place to send you notifications"
          checked={okToSendNotifications}
          onChange={updateUserNotificationPreference}
          id="pref-switch-notifications"
        />
        <PreferenceToggle
          label="Send me section reminders:"
          ariaLabel="Mark this switch if it is OK for Code in Place to send you notifications"
          checked={okToSendSectionReminders}
          onChange={updateUserSectionReminderPreference}
          id="pref-switch-section-reminders"
        />
      </div>
    </div>
  );
};

type PreferenceToggleProps = {
  label: string;
  ariaLabel: string;
  checked: boolean;
  onChange: () => void;
  id: string;
}

function PreferenceToggle({
  label,
  ariaLabel,
  checked,
  onChange,
  id,
}: PreferenceToggleProps) {
  const t = useTranslateFunction('miscUI');
  
  return (
    <div className="d-flex gap-2 justify-content-between align-items-start">
      <p>{t(label)}</p>
      <div className="d-flex gap-2 align-items-center">
        <b className={checked ? 'text-success' : 'text-danger'}>
          {checked ? t('Yes') : t('No')}
        </b>
        <Form>
          <Form.Check
            type="switch"
            id={id}
            aria-label={t(ariaLabel, {forceString: true})}
            checked={checked}
            onChange={onChange}
          />
        </Form>
      </div>
    </div>
  );
}
